import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import SliderInputPage from '../../components/SliderInputPage'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

export default function IntensityPreferencePage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const max = 50
  const valueEndurance = searchParams.get('endurance') || String(max / 2)
  const valueSpeed = searchParams.get('speed') || String(max / 2)
  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const formData = new FormData(event.currentTarget)

    const enduranceValue = Number(formData.get('endurance') as string)
    const speedValue = Number(formData.get('speed') as string)

    const answer = {
      question_key: 'intensity_preference',
      question: "What's your intensity preference?",
      answer_key: 'intensityPreference',
      answer: `Speed ${speedValue}, Endurance ${enduranceValue}`,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer('intensity_preference', answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <SliderInputPage
      heading={t('pages.onboarding.intensityPreference.heading')}
      onSubmit={onSubmit}
      inputNameEndurance="endurance"
      inputNameSpeed="speed"
      valueEndurance={valueEndurance}
      valueSpeed={valueSpeed}
      leftLabel={t('pages.onboarding.intensityPreference.leftLabel')}
      rightLabel={t('pages.onboarding.intensityPreference.rightLabel')}
    />
  )
}
